export default {
  required: "REQUIRED",
  emptyRequired: "EMPTY_REQUIRED",
  maxlengthRequired: "MAXLENGTH_REQUIRED",
  minLengthRequired: "MIN_LENGTH_REQUIRED",
  numberRequired: "NUMBER_REQUIRED",
  numberPositive: "NUMBER_POSITIVE",
  declarererRequired: "DECLARERER_REQUIRED",
  contractorRequired: "CONTRACTOR_REQUIRED",
  apartmentRequired: "APARTMENT_REQUIRED",
  characterProblemRequired: "CHARACTER_PROBLEM_REQUIRED",
  equipmentRequired: "EQUIPMENT_REQUIRED",
  blockRequired: "BLOCK_REQUIRED",
  tenantRequired: "TENANT_REQUIRED",
  managerRequired: "MANAGER_REQUIRED",
  originalRequestRequired: "ORIGINAL_REQUEST_REQUIRED",
  groupMemberRequired: "GROUP_MEMBER_REQUIRED",
  passwordRequired: "PASSWORD_REQUIRED",
  otherPasswordRequired: "OTHER_PASSWORD_REQUIRED",
  passwordMin: "PASSWORD_MIN",
  passwordValid: "PASSWORD_VALID",
  password_new: "PASSWORD_NEW",
  password_old: "PASSWORD_OLD",
  passwordMatching: "PASSWORD_MATCHING",
  cellphoneValid: "CELLPHONE_VALID",
  landlineValid: "LANDLINE_VALID",
  emailValid: "EMAIL_VALID",
  addressValid: "ADDRESS_VALID",
  closureReasonValid: "CLOSURE_REASON_VALID",
  independentContractorError: "INDEPENDENT_CONTRACTOR_ERROR",
  managersRequired: "MANAGERS_REQUIRED",
  companyRequired: "COMPANY_REQUIRED",
  apartmentEntityRequired: "APARTMENT_ENTITY_REQUIRED",
  ticketPriorityLevelRequired : 'TICKET_PRIORITY_LEVEL_REQUIRED',
  loginManagerRequired: "LOGIN_MANAGER_REQUIRED",
  ticketMinNameLength: "TICKET_MIN_NAME_LENGTH"
}



// WEBPACK FOOTER //
// ./src/locales/validation-messages/index.ts